import { RECEIVE_SHOPS } from './constants';

const initialState = {
  list: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_SHOPS:
      return {
        ...state,
        list: action.payload
      };
    default:
      return state;
  }
};

export default reducer;